import { useQuery } from 'react-query';

import { getTrackedItems as queryFn } from 'api/endPoints/getTrackedItems';

export const useQueryVersionCompareTrackedActivitiesTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['versionCompareTrackedActivitieTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
